<template>
	<div>
		<div class="card-title">{{card.regionName}}</div>
		<div class="card-content">
			<div class="card-content-left">
				<img src="@/assets/img/area.png" alt="area" />
			</div>
			<div class="card-content-right">
				<h4><label>在线数：</label><label>{{card.onlineCount}}</label></h4>
				<h4><label>处理中：</label><label>{{card.faultingCount}}</label></h4>
				<h4><label>新掉线：</label><label>{{card.newOfflineCount}}</label></h4>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'CsCard',
		props: ['card'],
		methods: {
		},
		mounted(){
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/card/CsCard.vue